import { combineReducers } from "redux";

import { alert } from "./alert.reducer";
import { billing } from "./billing.reducer";

const rootReducer = combineReducers({
    alert,
    billing,
});

export default rootReducer;
